import { clientFor, type PageQuery, type PageResult } from '@yc/api-client'

const api = clientFor('/dsp/api')

/** 线路状态：启用的固定班线才可挂到行车任务上 */
export type RouteStatus = 'active' | 'disabled'

/** 固定班线。字段与 services/dsp/internal/route/model.go 的 Route 一一对应。 */
export interface Route {
  id: number
  tenant_id: number
  code: string
  name: string
  origin: string
  dest: string
  distance_km: number
  est_minutes: number
  status: RouteStatus
  created_at: string
  updated_at: string
}

export interface RouteInput {
  code: string
  name?: string
  origin: string
  dest: string
  distance_km: number
  est_minutes: number
  status: RouteStatus
}

export interface RouteQuery extends PageQuery {
  keyword?: string
  status?: string
}

/** 与后端 services/dsp/internal/route/model.go 的 StatusNames 同源两份，改一边必须改另一边 */
export const STATUS_LABELS: Record<RouteStatus, string> = {
  active: '启用',
  disabled: '停用',
}

/** 状态 → 表格里的标签色 */
export const STATUS_TAG: Record<RouteStatus, 'info' | 'primary' | 'warning' | 'success' | 'danger'> = {
  active: 'success',
  disabled: 'info',
}

export const listRoutes = (q: RouteQuery): Promise<PageResult<Route>> =>
  api.get<PageResult<Route>>('/routes', { ...q })

export const createRoute = (input: RouteInput): Promise<Route> => api.post<Route>('/routes', input)

export const updateRoute = (id: number, input: RouteInput): Promise<Route> =>
  api.put<Route>(`/routes/${id}`, input)

export const deleteRoute = (id: number): Promise<void> => api.del<void>(`/routes/${id}`)

/** 下拉参照用的全量线路：后端 size 上限 200 */
export const listRouteOptions = (): Promise<Route[]> =>
  listRoutes({ page: 1, size: 200 }).then((page) => page.list)
